"use strict";
angular.module('rmTemplate')
    .config(['$stateProvider', $stateProvider => {

        async function createBladeIfNotExists(bladesManager, options, level = 0) {
            if (!bladesManager.all(level).some(el => el.viewName === options.viewName)) {
                await bladesManager.insertRight(options, level);
            }
        }

        $stateProvider

            .state('template', {
                url: "/template",
                views: {
                    'templateoverview': {
                        templateUrl: '/partial/app.partials.template.overview',
                        controller: 'TemplateOverviewCtrl',
                        controllerAs: 'templatectrl'
                    },
                    'templatedetail': {
                        templateUrl: '/partial/app.panels.empty'
                    }
                },
                onEnter: ['bladesManager', async bladesManager => {
                    await new Promise(resolve => bladesManager.clearAll(resolve));
                    await createBladeIfNotExists(bladesManager, {viewName: 'templateoverview', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'templatedetail', size: 'half'});
                }],
                onExit: ['bladesManager', async bladesManager => {
                    await bladesManager.removeRight({viewName: 'templateoverview', size: 'half'});
                    await bladesManager.removeRight({viewName: 'templatedetail', size: 'half'});
                }],
            })

            .state('template.update', {
                url: "/update/:id",
                views: {
                    'templatedetail@': {
                        controller: 'TemplateFormCtrl',
                        templateUrl: '/partial/app.partials.template.detail',
                        controllerAs: 'templatectrl'
                    }
                },
                params: {
                    create: false,
                },
                onEnter: ['bladesManager', async bladesManager => {
                    await createBladeIfNotExists(bladesManager, {viewName: 'templateoverview', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'templatedetail', size: 'half'});
                }],
            })

            .state('template.update.item', {
                url: '/item/:item_id/:ac',
                views: {
                    'itemDetail@': {
                        templateUrl: '/partial/app.partials.template.item_detail',
                        controller: 'TemplateItemCtrl',
                        controllerAs: 'ctrl'
                    }
                },
                params: {
                    item_data: null
                },
                onEnter: ['bladesManager', async bladesManager => {
                    await createBladeIfNotExists(bladesManager, {viewName: 'templateoverview', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'templatedetail', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'itemDetail', size: 'half'});
                }],
                onExit: ['bladesManager', '$state', async (bladesManager, $state) => {
                    if (!/^template\.update\.item/.test($state.transition.to().name)) {
                        await bladesManager.removeRight({viewName: 'itemDetail', size: 'half'});
                    }
                }],
            })

            .state('template.update.item.contact', {
                url: '/contact/:contactId',
                params: {
                    create: false
                },
                views: {
                    'contact@': {
                        templateUrl: '/partial/app.partials.contact.detail',
                        controller: 'ContactFormCtrl',
                        controllerAs: 'contactCtrl'
                    }
                },
                onEnter: ['bladesManager', async bladesManager => {
                    await createBladeIfNotExists(bladesManager, {viewName: 'templateoverview', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'templatedetail', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'itemDetail', size: 'half'});
                    await createBladeIfNotExists(bladesManager, {viewName: 'contact', size: 'half'});
                }],
                onExit: ['$state', '$stateParams', 'Contact', 'bladesManager', async ($state, $stateParams, Contact, bladesManager) => {

                    //ugly workaround to check if contact has actually been properly saved.. yeah...
                    let contact = Contact.get({id: $stateParams.contactId}, () => {
                        let contactHasProbablyBeenSaved = contact.firstname && contact.lastname;
                        if ($stateParams.create === true && !contactHasProbablyBeenSaved) {
                            Contact.delete({id: $stateParams.contactId});
                        }
                    });

                    if (!/^template\.update\.item\.contact/.test($state.transition.to().name)) {
                        await bladesManager.removeRight('contact');
                    }
                }]
            });
    }]);
